import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import * as css from './VisibilityChip.css';

type VisibilityChipProps = {
  showHidden: boolean;
  visibleCount: number;
  hiddenCount: number;
  onClick: () => void;
};

export const VisibilityChip = ({
  showHidden,
  visibleCount,
  hiddenCount,
  onClick,
}: VisibilityChipProps) => {
  return (
    <div className={css.chip} onClick={onClick}>
      <FontAwesomeIcon
        icon={showHidden ? faEyeSlash : faEye}
        className={css.chipIcon}
      />
      <span className={css.chipText}>
        {showHidden
          ? `Visible comments (${visibleCount})`
          : `Hidden comments (${hiddenCount})`}
      </span>
    </div>
  );
};
